module.exports = __webpack_public_path__ + "static/media/DownloadCenter.25093413.svg";